angular
  .module('caferealtor.reports.appointment', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/reports/appointments', {
        template: require('./report.html'),
        controller: 'AppointmentReportCtrl',
      });
    },
  ])

  .controller('AppointmentReportCtrl', [
    '$scope',
    '$resource',
    '$location',
    '$rootScope',
    '$routeParams',
    function ($scope, $resource, $location, $rootScope, $routeParams) {
      const AppointmentReport = $resource('/appointment/report');

      $scope.locations = ['All'];
      $resource('/org/locations')
        .get()
        .$promise.then(function (data) {
          _.each(data.locationIndex, function (loc) {
            $scope.locations.push(loc.name);
          });
        });

      $scope.groups = ['Users', 'Locations', 'Hourly'];

      $scope.search = {
        group: $scope.groups[0],
        location: $scope.locations[0],
        dateFrom: moment().subtract(30, 'day').toDate(),
        dateTo: moment().toDate(),
      };

      let currentSearch;
      $scope.generateReport = function () {
        currentSearch = { ...$scope.search };
        AppointmentReport.get($scope.search).$promise.then(function (data) {
          $scope.data = data;
        });
      };

      const serializeSearch = function () {
        const str = [];
        for (const p in currentSearch)
          if (currentSearch.hasOwnProperty(p)) {
            str.push(
              `${encodeURIComponent(p)}=${encodeURIComponent(
                currentSearch[p],
              )}`,
            );
          }
        return str.join('&');
      };

      $scope.downloadReport = function () {
        window.open(
          `/appointment/report/download?${serializeSearch()}`,
          '_blank',
        );
      };

      $scope.generateReport();
    },
  ]);
